import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'

interface SVGRProps {
    title?: string
    titleId?: string
}

function SvgBurgerMenu({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <rect x={3} y={6} width={18} height={2} rx={1} />
            <rect x={3} y={11} width={18} height={2} rx={1} />
            <rect x={3} y={16} width={18} height={2} rx={1} />
        </svg>
    )
}

SvgBurgerMenu.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}

export default SvgBurgerMenu
